const I18N_PREFIX = 'serviceName'

const getGlcServiceName = (service: string, { t }): string => t(`${I18N_PREFIX}.${service}`)

export default getGlcServiceName
